import { render, staticRenderFns } from "./ContractsPage.vue?vue&type=template&id=44215724&scoped=true"
import script from "./ContractsPage.vue?vue&type=script&lang=js"
export * from "./ContractsPage.vue?vue&type=script&lang=js"
import style0 from "./ContractsPage.vue?vue&type=style&index=0&id=44215724&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44215724",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44215724')) {
      api.createRecord('44215724', component.options)
    } else {
      api.reload('44215724', component.options)
    }
    module.hot.accept("./ContractsPage.vue?vue&type=template&id=44215724&scoped=true", function () {
      api.rerender('44215724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/plantNursery/contracts/ContractsPage.vue"
export default component.exports